import axios from 'axios'

export default function ({ baseURL }) {
    let service = axios.create({
        baseURL: baseURL,
        timeout: process.env.VUE_APP_REQUEST_TIME_OUT
    })

    /* 配置默认请求拦截器 */
    service.interceptors.request.use(config => {
        return config
    }, error => {
        return Promise.reject(error)
    })

    /* 配置默认响应拦截器 */
    service.interceptors.response.use(response => {
        // 返回结果
        return response.data.total !== undefined ? response.data : response.data.data
    }, error  => {
        return Promise.reject(error)
    })

    return service
}

/*
 * 功能：处理错误结果
 * Author：潘溢林
 */
function processErrorResult(result) {
    return Promise.reject(result)
}
